{
  "app.title": "مثبّت QuickHub",
  "app.tagline": "حوّل هاتف Pixel مدعومًا إلى خط QuickHub Voice",
  "app.lang.switch": "English",
  "app.signout": "تسجيل الخروج",
  "app.skip_to_content": "الانتقال إلى المحتوى",
  "app.status_region": "حالة المثبّت",

  "steps.signin": "تسجيل الدخول",
  "steps.preflight": "الفحص الأولي",
  "steps.unlock": "فتح القفل",
  "steps.flash": "التثبيت",
  "steps.enroll": "التسجيل",
  "steps.live": "جاهز",
  "steps.recovery": "الاستعادة",
  "steps.progress": "الخطوة {n} من {total}: {name}",
  "steps.group": "مجموعة الخط",
  "steps.member": "الانضمام للمجموعة",
  "steps.hoptest": "اختبار التحويل",
  "steps.remove": "إزالة هاتف",

  "common.continue": "متابعة",
  "common.back": "رجوع",
  "common.retry": "إعادة المحاولة",
  "common.cancel": "إلغاء",
  "common.copy": "نسخ",
  "common.copied": "تم النسخ",
  "common.loading": "جارٍ التحميل…",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.unknown": "غير معروف",
  "common.start_over": "البدء من جديد بهاتف آخر",
  "common.bytes_of": "{done} من {total}",

  "signin.heading": "سجّل الدخول بحساب QuickHub الخاص بك",
  "signin.intro": "استخدم حساب الشركة المالكة للخط. يتواصل المثبّت مع سحابة QuickHub فقط ولا يرسل بيانات هاتفك إلى أي جهة أخرى.",
  "signin.dev_token_label": "رمز الوصول",
  "signin.dev_token_hint": "وضع التطوير: الصق رمز Bearer من واجهة QuickHub. في الإنتاج يُستخدم تسجيل دخول QuickHub المعتاد.",
  "signin.button": "تسجيل الدخول",
  "signin.signing_in": "جارٍ تسجيل الدخول…",

  "models.heading": "الهواتف المدعومة",
  "models.purchase_spec": "اشترِ هاتف Google Pixel غير مقفل / إصدار دولي مع توفر خيار OEM unlocking. طرازات شركات الاتصالات الأمريكية (Verizon وAT&T وT-Mobile وXfinity وغيرها) لا يمكن فتح قفلها ويتم رفضها. Pixel 7 والأقدم غير مدعومة.",
  "models.col.model": "الطراز",
  "models.col.codename": "الاسم الرمزي",
  "models.col.tier": "الفئة",
  "models.col.updates": "تحديثات Google حتى",
  "models.col.status": "الحالة",
  "models.active": "متاح",
  "models.inactive": "لا يقبل تثبيتات جديدة",
  "models.tier.standard": "قياسي",
  "models.tier.budget": "اقتصادي / مجدَّد — تسجيل وتفريغ نصي",
  "models.tier.successor": "الخليفة",
  "models.tier.agent": "فئة الوكيل الذكي",

  "browser.heading": "فحص المتصفح",
  "browser.ok": "Chrome / Edge على حاسوب مكتبي مع WebUSB — جاهز.",
  "browser.not_chromium": "يحتاج هذا المثبّت إلى متصفح Chromium (Google Chrome أو Microsoft Edge). Firefox وSafari لا يدعمان WebUSB.",
  "browser.not_desktop": "استخدم حاسوبًا مكتبيًا أو محمولًا. لا يمكن للهواتف والأجهزة اللوحية تثبيت النظام على هاتف آخر.",
  "browser.no_webusb": "WebUSB غير متاح. تأكد من أن الوصول إلى USB غير معطّل بسياسة النظام وأن الصفحة محمّلة عبر https.",
  "browser.insecure": "يجب تحميل الصفحة عبر https.",

  "drivers.heading": "تعريف USB لنظام {os}",
  "drivers.windows": "ثبّت Google USB Driver ثم أعد توصيل الهاتف. سيظهر في Windows باسم \"Android Bootloader Interface\".",
  "drivers.windows_link": "تنزيل Google USB Driver",
  "drivers.linux": "أضف قاعدة udev ليتمكن مستخدمك من التواصل مع الهاتف، ثم افصل الكابل وأعد توصيله:",
  "drivers.macos": "لا حاجة إلى تعريف على macOS.",
  "drivers.chromeos": "لا حاجة إلى تعريف على ChromeOS.",
  "drivers.unsupported": "نظام التشغيل هذا غير مدعوم من المثبّت.",
  "drivers.copy_rule": "نسخ الأوامر",

  "preflight.heading": "وصّل الهاتف في وضع fastboot",
  "preflight.step1": "أطفئ الهاتف تمامًا.",
  "preflight.step2": "اضغط مطولًا على زر خفض الصوت مع زر التشغيل حتى تظهر شاشة \"Fastboot Mode\" (نص أحمر على خلفية سوداء).",
  "preflight.step3": "وصّله بهذا الحاسوب بكابل USB لنقل البيانات. يُفضَّل منفذ في الحاسوب نفسه وليس موزّعًا.",
  "preflight.connect": "توصيل الهاتف",
  "preflight.connecting": "جارٍ قراءة الهاتف…",
  "preflight.reconnect": "إعادة توصيل الهاتف",
  "preflight.reconnect_hint": "أُعيد تحميل الصفحة. اختر الهاتف نفسه في نافذة المتصفح للمتابعة من حيث توقفت.",
  "preflight.device_heading": "الهاتف",
  "preflight.device.product": "رمز الطراز",
  "preflight.device.serial": "الرقم التسلسلي",
  "preflight.device.unlocked": "محمّل الإقلاع مفتوح",
  "preflight.device.slot": "الفتحة النشطة",
  "preflight.device.anti_rollback": "منع التراجع",
  "preflight.device.bootloader": "محمّل الإقلاع",
  "preflight.device.baseband": "الراديو",
  "preflight.device.unlock_ability": "فتح OEM مسموح",
  "preflight.ok": "تم اكتشاف {model} — مدعوم.",
  "preflight.refused.needs_bootloader_mode": "الهاتف في وضع fastboot لمساحة المستخدم (fastbootd). أعد تشغيله إلى محمّل الإقلاع وحاول مجددًا.",
  "preflight.refused.unsupported_model": "\"{product}\" ليس طرازًا مدعومًا. المدعوم: {models}.",
  "preflight.refused.model_inactive": "{model} لا يقبل تثبيتات جديدة حاليًا.",
  "preflight.refused.carrier_locked": "يفيد محمّل الإقلاع بأن فتح القفل غير مسموح. إما أن OEM unlocking معطّل في خيارات المطوّر (فعّله، ثم أعد التشغيل إلى fastboot وحاول مجددًا) أو أن هذه الوحدة مقفلة من شركة اتصالات ولا يمكنها تشغيل QuickHub OS.",
  "preflight.refused.us_carrier_variant": "يبدو أن هذا هاتف من شركة اتصالات أمريكية ({carrier}). لا يمكن فتح قفل محمّل الإقلاع في وحدات شركات الاتصالات ولا يمكنها تشغيل QuickHub OS. أعده واشترِ طرازًا غير مقفل / دوليًا.",
  "preflight.refused.anti_rollback": "محمّل إقلاع الهاتف أحدث من إصدار QuickHub OS المخصص له (منع التراجع). انتظر إصدار QuickHub OS التالي.",
  "preflight.warn.us_carrier_variant": "تحذير: تبدو سلاسل محمّل الإقلاع كنسخة شركة اتصالات أمريكية ({carrier}). قد يرفض الهاتف فتح القفل.",
  "preflight.warn.unlock_ability_unknown": "لا يبلّغ محمّل الإقلاع هذا عن إمكانية فتح OEM؛ ستتضح في خطوة فتح القفل.",
  "preflight.already_unlocked": "محمّل الإقلاع مفتوح بالفعل — سيتم تخطي خطوة فتح القفل.",

  "sim.heading": "هل الشريحة جاهزة؟",
  "sim.intro": "لا يحتوي QuickHub OS على مدير eSIM (مدير Google جزء من خدمات Play التي لا يشحنها QuickHub OS). الشريحة المادية تعمل ببساطة. أما ملف eSIM فيستمر في العمل بعد التثبيت فقط إذا كان مفعَّلًا على هذا الهاتف مسبقًا — لذا فعّله الآن على Android الأصلي وأجرِ مكالمة تجريبية قبل المتابعة.",
  "sim.option.physical": "شريحة مادية مُدخلة في الهاتف.",
  "sim.option.esim_activated": "ملف eSIM مفعَّل بالفعل على هذا الهاتف ويعمل على Android الأصلي (أجريتُ مكالمة تجريبية).",
  "sim.consequence": "النتيجة بالنسبة لـ eSIM: بعد تثبيت QuickHub OS لا يمكن إضافة الملف أو تبديله أو حذفه على الهاتف. لتغييره لاحقًا يجب استعادة نظام Android الأصلي من Google (الاستعادة)، ثم تغيير eSIM هناك، ثم تثبيت QuickHub OS من جديد. أما الشرائح المادية فيمكن تبديلها في أي وقت.",
  "sim.confirm_label": "أؤكد أن الشريحة في هذا الهاتف جاهزة كما هو محدد أعلاه",
  "sim.button": "تأكيد جاهزية الشريحة",
  "sim.confirmed.physical": "تم تأكيد الشريحة: شريحة مادية مُدخلة.",
  "sim.confirmed.esim_activated": "تم تأكيد الشريحة: ملف eSIM مفعَّل ومُختبَر على Android الأصلي.",
  "sim.esim_note.recovery": "eSIM: لا يمكن إضافة ملف أو تبديله أو حذفه إلا على Android الأصلي — فليس في QuickHub OS مدير eSIM. لتغيير eSIM هاتف ما، استعد النظام الأصلي، غيّر الملف هناك، ثم أعد تثبيت QuickHub OS. الشرائح المادية لا تتأثر.",
  "sim.esim_note.remove": "إذا كان الهاتف المُزال يستخدم eSIM، فلا يمكن تغيير ملفه إلا بعد استعادة نظام Android الأصلي من Google (قسم الاستعادة، بعد اكتمال هذه الإزالة). الشرائح المادية يمكن تبديلها في أي وقت.",
  "sim.esim_note.stock": "يمكن إدارة ملفات eSIM على هذا الهاتف من جديد (الإعدادات › الشبكة والإنترنت › شرائح SIM). إذا كان سيعمل بـ QuickHub OS مرة أخرى، فعّل أو غيّر eSIM هنا أولًا وأجرِ مكالمة تجريبية.",

  "unlock.heading": "فتح قفل محمّل الإقلاع",
  "unlock.warning_title": "هذا يمسح كل ما على الهاتف",
  "unlock.warning_body": "فتح القفل يمسح جميع البيانات والحسابات والتطبيقات. سيصبح الهاتف تابعًا لخط QuickHub هذا. تأكد من عدم الحاجة إلى أي شيء عليه.",
  "unlock.oem_heading": "أولًا، فعّل OEM unlocking على الهاتف (مرة واحدة)",
  "unlock.oem1": "شغّل الهاتف بشكل طبيعي وسجّل الخروج من أي حساب Google (الإعدادات › كلمات المرور والحسابات).",
  "unlock.oem2": "الإعدادات › حول الهاتف › انقر على \"رقم الإصدار\" سبع مرات.",
  "unlock.oem3": "الإعدادات › النظام › خيارات المطوّر › فعّل \"OEM unlocking\" (يحتاج اتصالًا بالإنترنت مرة واحدة؛ إن كان رماديًا فالوحدة مقفلة من شركة اتصالات).",
  "unlock.oem4": "أطفئ الهاتف، اضغط مطولًا على خفض الصوت + التشغيل للعودة إلى Fastboot Mode، وأعد توصيل الكابل.",
  "unlock.oem_done": "OEM unlocking مفعّل والهاتف عاد إلى fastboot",
  "unlock.confirm_label": "اكتب {word} لتأكيد المسح",
  "unlock.confirm_word": "ERASE",
  "unlock.button": "فتح القفل والمسح",
  "unlock.on_phone": "على الهاتف: استخدم أزرار الصوت لتحديد \"Unlock the bootloader\" واضغط زر التشغيل. يمسح الهاتف نفسه ويعود إلى fastboot؛ تتابع هذه الصفحة تلقائيًا.",
  "unlock.waiting": "في انتظار عودة الهاتف…",

  "flash.heading": "جارٍ تثبيت QuickHub OS",
  "flash.heading_stock": "جارٍ استعادة نظام Android الأصلي من Google",
  "flash.phase.manifest": "جلب بيان الإصدار الموقّع والتحقق منه",
  "flash.phase.download": "تنزيل حزمة الصور (يُستأنف عند الانقطاع)",
  "flash.phase.flashing": "جارٍ الكتابة على الهاتف — لا تفصل الكابل",
  "flash.phase.locking": "قفل محمّل الإقلاع",
  "flash.phase.done": "اكتمل",
  "flash.build": "الإصدار {build}",
  "flash.file_progress": "الملف {n} من {total}: {name}",
  "flash.part_progress": "جارٍ كتابة {name}",
  "flash.start": "بدء",
  "flash.resume": "استئناف",
  "flash.lock_on_phone": "على الهاتف: حدّد \"Lock the bootloader\" بأزرار الصوت واضغط زر التشغيل.",
  "flash.reboot_note": "يعيد الهاتف التشغيل عدة مرات خلال هذه الخطوة. أبقِه موصولًا.",
  "flash.leave_unlocked_note": "سيُترك محمّل الإقلاع مفتوحًا كما طُلب.",

  "enroll.heading": "تسجيل الهاتف",
  "enroll.intro": "يقلع الهاتف بنظام QuickHub OS للمرة الأولى. في شاشة الإعداد على الهاتف، امسح هذا الرمز أو اكتب الرمز النصي.",
  "enroll.token_label": "رمز لمرة واحدة",
  "enroll.expires": "ينتهي {when}",
  "enroll.qr_alt": "رمز QR للتسجيل",
  "enroll.request": "الحصول على رمز تسجيل",
  "enroll.state.pending": "في انتظار استخدام الهاتف للرمز",
  "enroll.state.token_consumed": "قُبل الرمز — يطلب الهاتف شهادته",
  "enroll.state.enrolled": "صدرت الشهادة — جارٍ فحص القدرات",
  "enroll.state.probed": "تم الإبلاغ عن القدرات — جارٍ الإنهاء",
  "enroll.state.live": "الخط جاهز",
  "enroll.state.expired": "انتهت صلاحية الرمز",
  "enroll.state.failed": "فشل التسجيل",

  "live.heading": "{group} — الهاتف {position} من {total} يعمل",
  "live.intro": "الهاتف مسجّل ويبلّغ QuickHub. يمكنك إغلاق هذه الصفحة.",
  "live.device": "الجهاز {id}",
  "live.caps.heading": "القدرات",
  "live.caps.capture_downlink": "التقاط صوت المتصل",
  "live.caps.capture_uplink": "التقاط صوت الهاتف",
  "live.caps.uplink_injection": "وكيل صوتي ذكي (حقن الصوت)",
  "live.caps.call_screening_mode": "وضع فرز المكالمات",
  "live.recording_only": "يبلّغ هذا الهاتف عن عدم دعم حقن الصوت: سيسجّل الخط المكالمات ويفرّغها نصيًا لكنه لا يستطيع تشغيل الوكيل الصوتي الذكي عليها.",
  "live.stock_heading": "تمت استعادة Android الأصلي",
  "live.stock_intro": "يعمل الهاتف الآن بصورة المصنع من Google. لم يعد جزءًا من خط QuickHub.",
  "live.stock_unlocked": "تُرك محمّل الإقلاع مفتوحًا.",
  "live.another": "تثبيت هاتف آخر",
  "live.hop_test_passed": "اختبار التحويل المباشر: نجح وحُفظ في سجل التدقيق.",
  "live.hop_test_skipped": "اختبار التحويل المباشر: تم تخطيه (قرأ كل هاتف الحالة المطلوبة).",
  "live.forwarding_heading": "تحويل هذا الهاتف (كما قُرئ من المشغّل)",
  "live.caps.hold_supported": "تعليق / استئناف",
  "live.caps.call_waiting_delivered": "تسليم المكالمات المنتظرة",
  "live.caps.forwarding_api": "واجهة التحويل",

  "error.heading": "حدث خطأ ما",
  "error.device_disconnected": "انقطع اتصال الهاتف. تحقق من الكابل وتأكد من عودته إلى Fastboot Mode ثم أعد المحاولة.",
  "error.not_in_fastboot": "جهاز USB المحدد ليس في وضع fastboot.",
  "error.webusb_unsupported": "لا يستطيع هذا المتصفح الوصول إلى أجهزة USB.",
  "error.no_device_selected": "لم يتم اختيار هاتف في نافذة المتصفح.",
  "error.wrong_device": "هذا هاتف مختلف عن الهاتف الذي بدأت به هذه الجلسة.",
  "error.fastboot_fail": "رفض الهاتف أمرًا: {message}",
  "error.fastboot_protocol": "رد غير متوقع من الهاتف: {message}",
  "error.fastboot_too_large": "إحدى الصور أكبر مما يقبله محمّل الإقلاع هذا.",
  "error.manifest_signature": "توقيع بيان الإصدار غير صالح. لم يتم الوثوق بالتنزيل. تواصل مع الدعم.",
  "error.manifest_unknown_key": "وُقّع بيان الإصدار بمفتاح لا يعرفه هذا المثبّت. حدّث المثبّت.",
  "error.manifest_shape": "بيان الإصدار تالف: {message}",
  "error.manifest_google_mismatch": "محمّل الإقلاع أو الراديو في الحزمة لا يطابق صورة Google المنشورة. تم رفض التثبيت.",
  "error.manifest_model_mismatch": "هذه الحزمة لا تناسب هذا الهاتف: {message}",
  "error.download_http": "فشل التنزيل: {message}",
  "error.download_size": "أعاد التنزيل كمية بيانات غير صحيحة.",
  "error.download_sha256": "فشلت إحدى الصور المنزّلة في فحص السلامة وتم تجاهلها. أعد المحاولة لتنزيلها مجددًا.",
  "error.download_aborted": "أُلغي التنزيل.",
  "error.unauthenticated": "انتهت جلستك. سجّل الدخول مجددًا.",
  "error.api": "خطأ في سحابة QuickHub: {message}",
  "error.unlock_not_confirmed": "أكّد المسح أولًا.",
  "error.sim_not_confirmed": "أكّد قائمة الشريحة أولًا: شريحة مادية مُدخلة، أو ملف eSIM مفعَّل ومُختبَر على Android الأصلي.",
  "error.carrier_locked": "رفض الهاتف فتح القفل. OEM unlocking معطّل أو أن هذه وحدة مقفلة من شركة اتصالات.",
  "error.unlock_declined": "لا يزال الهاتف مقفلًا. اختر \"Unlock the bootloader\" على الهاتف ثم أعد المحاولة.",
  "error.enrollment_expired": "انتهت صلاحية رمز التسجيل. اطلب رمزًا جديدًا.",
  "error.enrollment_failed": "فشل التسجيل: {message}",
  "error.unexpected": "خطأ غير متوقع: {message}",
  "error.wrong_step": "خطأ داخلي: {message}",
  "error.guard_group_full": "تضم مجموعة الخط 5 هواتف كحد أقصى (يحدّ المشغّلون قفزات التحويل). استبدل هاتفاً بدلاً من الإضافة.",
  "error.guard_same_phone_hop": "سيوجّه ذلك شريحة إلى شريحة أخرى في نفس الهاتف؛ الهاتف يحمل مكالمة واحدة فقط. {message}",
  "error.guard_loop": "سيُنشئ ذلك حلقة تحويل: {message}",
  "error.guard_invalid_number": "أدخل الرقم بصيغة E.164 (‎+9715xxxxxxxx): {message}",
  "error.guard_licence_not_attested": "علّم إقرار الرخصة وأدخل اسمك.",
  "error.guard_position_taken": "{message}",
  "error.guard_position_unknown": "{message}",
  "error.api_group_full": "رفضت السحابة: تضم المجموعة 5 هواتف بالفعل.",
  "error.api_same_phone_hop": "رفضت السحابة: هذا الهاتف يحمل عضواً في المجموعة بالفعل.",
  "error.api_loop": "رفضت السحابة: هذا الرقم عضو بالفعل (حلقة).",
  "error.api_licence_not_attested": "رفضت السحابة: إقرار الرخصة مفقود.",
  "error.chain_job_failed": "تعذّر على السحابة برمجة سلسلة التحويل: {message}",
  "error.forwarding_out_of_sync": "قرأ أحد الهواتف حالة تحويل غير مطابقة: {message}. شغّل المطابقة مرة أخرى؛ وإن استمر الفشل فتأكد أن الباقة مفعَّل فيها تحويل المكالمات.",
  "error.hop_test_failed": "لم ينجح اختبار التحويل المباشر: {message}",
  "error.hop_test_required": "اختبار التحويل المباشر إلزامي: أبلغ أحد الهواتف عن حالة تحويل غير مُتحقَّق منها.",
  "error.not_live_yet": "لم تعلّم السحابة الخط كمباشر بعد: {message}",
  "error.member_not_removed": "{message}",

  "logs.heading": "التشخيص",
  "logs.download": "تنزيل ملف السجل",
  "logs.upload": "إرسال السجلات إلى دعم QuickHub",
  "logs.uploaded": "تم الإرسال. مرجع الدعم: {ticket}",
  "logs.entries": "{n} إدخال في السجل",
  "logs.session": "الجلسة {id}",

  "group.heading": "اختر مجموعة الخط لهذا الهاتف",
  "group.intro": "مجموعة الخط هي من 1 إلى 5 هواتف، لكل منها شريحة أعمال خاصة، مترابطة عبر تحويل المكالمات لدى المشغّل بحيث يرنّ الهاتف التالي المتاح عند اتصال متصلٍ ثانٍ بالرقم الرئيسي. الهاتف الواحد هو مجموعة من هاتف واحد. اختر المجموعة التي ينضم إليها هذا الهاتف أو أنشئ مجموعة جديدة — رقمها الرئيسي هو الرقم الذي يتصل به العملاء وسيحمله هذا الهاتف.",
  "group.none": "لا توجد مجموعات بعد — أنشئ واحدة أدناه.",
  "group.members_count": "{n} من {max} هواتف",
  "group.status.ok": "متزامنة",
  "group.status.degraded": "متدهورة",
  "group.status.unverified": "غير مُتحقَّق منها",
  "group.create_name": "اسم المجموعة الجديدة",
  "group.create_number": "الرقم الرئيسي (E.164)",
  "group.create_button": "إنشاء مجموعة",
  "group.create_hint": "الرقم الرئيسي هو شريحة هذا الهاتف. اكتبه مع رمز الدولة، مثل ‎+9715xxxxxxxx.",
  "group.sim_req.heading": "ما يحتاجه كل هاتف في المجموعة",
  "group.sim_req.licence": "شريحة أعمال خاصة به مسجَّل رقمها تحت الرخصة التجارية للشركة (مطلوب لأي رقم يُستخدم في المكالمات التسويقية).",
  "group.sim_req.forwarding": "باقة مفعَّل فيها تحويل المكالمات (باقات الأعمال لدى du وe& تشملها عادةً — تأكد حسب الباقة).",
  "group.sim_req.billing": "الموافقة على أن أجزاء المكالمات المحوَّلة قد تُحتسب على الرقم المحوِّل كمكالمات صادرة.",
  "group.sim_req.visible": "المكالمات الصادرة من هاتف تُظهر رقم ذلك الهاتف، لذا سيرى العملاء كل رقم من أرقام الأعضاء.",
  "group.plan_create": "\"{group}\" ليس فيها هاتف بعد. سيصبح هذا الهاتف العضو 1 ويحمل الرقم الرئيسي {number}.",
  "group.plan_add": "سيصبح هذا الهاتف العضو {position} في \"{group}\". سيحوّل الهاتف {previous} مكالمات المشغول / عدم الرد / عدم الوصول إليه ويُوقف انتظار المكالمات لديه؛ ويصبح هذا الهاتف العضو الأخير مع تفعيل انتظار المكالمات.",
  "group.plan_full": "\"{group}\" تضم بالفعل {max} هواتف، وهو الحد الأقصى لسلسلة التحويل لدى المشغّل. استبدل هاتفاً بدلاً من الإضافة، أو انتقل إلى خط SIP لمزيد من التزامن.",
  "group.use_create": "استخدام هذه المجموعة (العضو 1)",
  "group.use_add": "إضافة هذا الهاتف إلى المجموعة",
  "group.replace_heading": "استبدال هاتف موجود (معطّل أو مُحدَّث)",
  "group.replace_hint": "يأخذ الهاتف الجديد نفس الموضع ونفس الشريحة. لا يُعاد توجيه الهاتف السابق إلا إذا تغيّر الرقم. إذا كان الهاتف القديم معطّلاً، يبقى تحويله صالحاً لأنه لدى المشغّل.",
  "group.replace_position": "الهاتف المراد استبداله",
  "group.replace_button": "استبدال هذا العضو بالهاتف المتصل",
  "group.position_pick": "اختر…",
  "group.position_option": "الهاتف {position} · {number} · {role}",
  "group.recovery_heading": "الاستعادة لهاتف موجود",
  "group.recovery_hint": "كلا الخيارين يمسح الهاتف. إعادة التثبيت تعيد تسجيله في نفس الموضع بنفس الشريحة. استعادة نظام Google الأصلي تزيل مفتاح الإقلاع الموثَّق لـ QuickHub.",
  "group.recovery_position": "أي هاتف (الموضع في المجموعة)",
  "group.recovery_leave_unlocked": "ترك محمّل الإقلاع مفتوحاً (لإرجاع الهاتف)",
  "group.recovery_reflash": "إعادة تثبيت QuickHub OS",
  "group.recovery_stock": "استعادة نظام Android الأصلي من Google",
  "group.recovery_remove_first": "لا يمكن مسح هاتف ما زال عضواً مسجَّلاً: التحويل موجود على شبكة المشغّل، لذا أزِله من المجموعة أولاً (أدناه) وإلا ستستمر المكالمات في التدفق إلى هاتف لا يجيب.",
  "group.remove_heading": "إزالة هاتف من المجموعة",
  "group.remove_hint": "لا حاجة لتوصيل هاتف. تعيد السحابة توجيه الهاتف السابق متجاوزةً هذا الهاتف أولاً، ثم تمسح تحويله وتنتظر القراءات. عندها فقط يُسمح بالمسح أو الإرجاع.",
  "group.remove_position": "الهاتف المراد إزالته",
  "group.remove_force": "الهاتف معطّل أو لا يمكن الوصول إليه (سأمسح تحويله بطلب ‎##002#‎ على تلك الشريحة من أي هاتف)",
  "group.remove_button": "إزالة هذا الهاتف",

  "fwd.member": "الهاتف {position} · {number} · {role}",
  "fwd.role.main": "الرقم الرئيسي",
  "fwd.role.middle": "وسط",
  "fwd.role.last": "الأخير (انتظار المكالمات مفعَّل)",
  "fwd.source": "مصدر القراءة: {source}",
  "fwd.source.network_query": "استعلام الشبكة (مُتحقَّق)",
  "fwd.source.unverified": "غير مُتحقَّق — تعذّر على الهاتف قراءة حالة المشغّل",
  "fwd.source.none": "لا قراءة بعد",
  "fwd.readback_at": "قُرئت في {when}",
  "fwd.col.rule": "القاعدة",
  "fwd.col.desired": "المطلوب",
  "fwd.col.actual": "قراءة الهاتف",
  "fwd.col.ok": "مطابقة",
  "fwd.rule.busy": "تحويل عند الانشغال",
  "fwd.rule.no_reply": "تحويل عند عدم الرد",
  "fwd.rule.not_reachable": "تحويل عند عدم الوصول",
  "fwd.rule.unconditional": "تحويل غير مشروط",
  "fwd.rule.call_waiting": "انتظار المكالمات",

  "sync.in_sync": "متزامن",
  "sync.out_of_sync": "غير متزامن",
  "sync.unverified": "غير مُتحقَّق",
  "sync.repairing": "قيد الإصلاح",

  "job.state.pending": "بانتظار بدء السحابة",
  "job.state.reprogramming": "إعادة برمجة التحويل على الهواتف",
  "job.state.awaiting_readback": "بانتظار قراءة الهواتف لحالة المشغّل",
  "job.state.done": "تمت برمجة السلسلة والتحقق منها",
  "job.state.failed": "فشلت برمجة السلسلة",
  "job.step": "الهاتف {position}: {action} — {state}",
  "job.action.program": "برمجة التحويل",
  "job.action.forwarding_set": "ضبط التحويل",
  "job.action.call_waiting_set": "ضبط انتظار المكالمات",
  "job.action.readback": "قراءة الحالة",
  "job.action.erase_forwarding": "مسح التحويل",
  "job.action.repoint": "إعادة التوجيه إلى العضو التالي",
  "job.action.config": "إرسال إعدادات المجموعة",
  "job.step_state.pending": "معلّق",
  "job.step_state.running": "جارٍ",
  "job.step_state.sent": "أُرسل",
  "job.step_state.awaiting_readback": "بانتظار القراءة",
  "job.step_state.done": "تم",
  "job.step_state.failed": "فشل",
  "job.step_state.skipped": "تم التخطي",

  "member.heading": "الانضمام إلى \"{group}\" كهاتف {position}",
  "member.intro_create": "يصبح هذا الهاتف العضو 1 ويحمل الرقم الرئيسي {number}. وهو أيضاً العضو الأخير حالياً: بلا تحويل، مع تفعيل انتظار المكالمات.",
  "member.intro_add": "يصبح هذا الهاتف العضو {position}. ستجعل السحابة الهاتف {previous} يحوّل إليه وتوقف انتظار المكالمات لدى الهاتف {previous}، ثم تضبط هذا الهاتف كعضو أخير.",
  "member.intro_replace": "يستبدل هذا الهاتف العضو {position} محتفظاً بنفس الموضع والشريحة. لا يُعاد توجيه الهاتف السابق إلا إذا تغيّر الرقم.",
  "member.number_label": "رقم شريحة هذا الهاتف (E.164)",
  "member.number_hint": "لا يستطيع المثبّت قراءة الشريحة عبر fastboot. يظهر الرقم على شاشة الإعداد في الهاتف (وفي لوحة QuickHub بعد التسجيل) — انسخه هنا وأكّده.",
  "member.number_prefilled": "مُعبّأ مسبقاً مما أبلغ عنه الهاتف عند التسجيل. تأكد أنه يطابق الشريحة في الهاتف.",
  "member.attest_heading": "إقرار الرخصة",
  "member.attest_label": "أؤكد أن {number} مسجَّل تحت الرخصة التجارية لهذه الشركة وأن الباقة مفعَّل فيها تحويل المكالمات.",
  "member.attested_by": "اسمك (يُسجَّل مع الإقرار)",
  "member.attest_hint": "تشترط قواعد التسويق الهاتفي في الإمارات تسجيل كل رقم يُستخدم في مكالمات الأعمال تحت رخصة الشركة. يُحفظ الإقرار في سجل تدقيق المجموعة.",
  "member.submit": "إضافة إلى المجموعة",
  "member.submit_replace": "استبدال العضو",
  "member.programming": "جارٍ برمجة السلسلة للرقم {number}…",
  "member.expect_previous": "الهاتف {position}: تحويل عند الانشغال وعدم الرد وعدم الوصول ← الهاتف {next}؛ انتظار المكالمات موقوف.",
  "member.expect_new": "الهاتف {position}: بلا تحويل؛ انتظار المكالمات مفعَّل (أصبح العضو الأخير).",
  "member.expect_readback": "بانتظار أن يقرأ الهاتفان حالة المشغّل وتتطابق.",
  "member.repair": "تشغيل المطابقة مرة أخرى",

  "hoptest.heading": "التحقق من السلسلة بمكالمة حقيقية",
  "hoptest.readback_heading": "ما قرأته الهواتف",
  "hoptest.required": "تعذّر على أحد الهواتف التحقق من حالة التحويل لدى المشغّل (غير مُتحقَّق). اختبار التحويل المباشر إلزامي قبل تشغيل هذا الخط.",
  "hoptest.optional": "قرأ كل هاتف الحالة المطلوبة. اختبار التحويل المباشر اختياري لكنه مُستحسن بعد تغيير السلسلة.",
  "hoptest.instructions": "أدخل رقم جوال العميل. ستجعل السحابة الهواتف مشغولة قفزةً تلو الأخرى باستخدام خط اختبار QuickHub؛ عندما تطلب الصفحة ذلك، اتصل بالرقم الرئيسي {main} من ذلك الجوال ودعه يرنّ.",
  "hoptest.caller_label": "رقم جوال المتصل (ليس عضواً في المجموعة)",
  "hoptest.no_reply_label": "اختبر أيضاً التحويل عند عدم الرد (اترك الهاتف المستهدف دون رد طوال مهلة عدم الرد)",
  "hoptest.start": "بدء اختبار التحويل",
  "hoptest.skip": "تخطي الاختبار",
  "hoptest.running": "الاختبار جارٍ — اتبع التعليمات أدناه",
  "hoptest.passed": "نجح اختبار التحويل",
  "hoptest.failed": "فشل اختبار التحويل",
  "hoptest.call_now": "اتصل الآن بـ {main} من {caller}، ثم مرة أخرى لكل قفزة عند تعليم القفزة السابقة.",
  "hoptest.col.hop": "القفزة",
  "hoptest.col.expected": "ينبغي أن يرنّ",
  "hoptest.col.rang": "رنّ",
  "hoptest.col.ttr": "زمن الرنين",
  "hoptest.col.forwarded_from": "محوَّل من",
  "hoptest.col.result": "النتيجة",
  "hoptest.member": "الهاتف {position} ({number})",
  "hoptest.outcome.pending": "بانتظار اتصالك…",
  "hoptest.outcome.ok": "سليم",
  "hoptest.outcome.wrong_member": "رنّ الهاتف الخطأ",
  "hoptest.outcome.no_ring": "لم يرنّ شيء",
  "hoptest.no_reply_row": "عدم الرد",
  "hoptest.audit": "حُفظ في سجل تدقيق المجموعة في {when} ({action}):",
  "hoptest.finish": "إنهاء — تعليم الخط كمباشر",
  "hoptest.rerun": "إعادة الاختبار",

  "remove.heading": "إزالة الهاتف {position} من \"{group}\"",
  "remove.intro": "التحويل موجود على شبكة المشغّل لا على الهاتف، لذا الترتيب مهم:",
  "remove.order1": "يُعاد توجيه الهاتف السابق متجاوزاً هذا الهاتف (أو إذا كان هذا الهاتف الأخير، يصبح السابق هو الأخير: التحويل موقوف، انتظار المكالمات مفعَّل).",
  "remove.order2": "يمسح هذا الهاتف تحويله بنفسه ويقرأ النتيجة.",
  "remove.order2_force": "هذا الهاتف معطّل، لذا أنت من يمسح تحويله: اطلب ‎##002#‎ على تلك الشريحة من أي هاتف.",
  "remove.order3": "عندها فقط يجوز مسح الهاتف أو استعادة النظام الأصلي أو إرجاعه.",
  "remove.dead_heading": "مسح التحويل على الشريحة المُزالة",
  "remove.dead_body": "ضع الشريحة في أي هاتف واطلب:",
  "remove.dead_hint": "هذا هو رمز GSM القياسي الذي يمسح كل قواعد تحويل المكالمات على ذلك الرقم. يعرض الهاتف تأكيداً من المشغّل.",
  "remove.dead_confirm_label": "طلبتُ {code} على تلك الشريحة وأكّد المشغّل مسح التحويل",
  "remove.dead_confirm_button": "تأكيد وإغلاق الإزالة",
  "remove.done": "الهاتف {position} خارج المجموعة والسلسلة مُتحقَّق منها.",
  "remove.done_next": "يمكنك الآن مسحه أو استعادة نظام Android الأصلي من قسم الاستعادة.",
  "remove.back": "العودة إلى مجموعات الخطوط"
}
